import { render, staticRenderFns } from "./SecurityMark.vue?vue&type=template&id=32389512&scoped=true"
import script from "./SecurityMark.vue?vue&type=script&lang=js"
export * from "./SecurityMark.vue?vue&type=script&lang=js"
import style0 from "./SecurityMark.vue?vue&type=style&index=0&id=32389512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32389512",
  null
  
)

export default component.exports